type CalendarEventLike<T extends { id?: string }> = {
  id?: string;
  extendedProps: T & { calendarItemId?: string };
};

export const preserveCalendarItemId = <T extends { id?: string }>(
  item: T
): T & { calendarItemId?: string } => ({
  ...item,
  calendarItemId: item.id,
});

export const restoreCalendarItemId = <T extends { id?: string }>(
  event: CalendarEventLike<T>
): T => ({
  ...event.extendedProps,
  id: event.extendedProps.calendarItemId || event.id || event.extendedProps.id,
});
